angular
    .module('festzelt-os.vouchers.templates', [
        'ui.router',
        'festzelt-os.components'
    ]);

require('./routes');

// Factories
require('./factories/voucher-template-factory');

// Store
require('./store/voucher-templates');



// WEBPACK FOOTER //
// ./src/app/pages/vouchers/templates/module.js